import { Button, Loader } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";

interface RedirectScreenProps {
    explanation?: string;
    to: string;
}

export const RedirectScreen: React.FC<RedirectScreenProps> = ({
    explanation,
    to,
}) => {
    const { t } = useTranslation();

    // Debug logging for test/staging environments
    React.useEffect(() => {
        if (window.location.hostname.toLowerCase().includes('test') || window.location.hostname.toLowerCase().includes('staging')) {
            console.log('=== REDIRECT SCREEN ===');
            console.log('Redirect target URL:', to);
            console.log('Current URL:', window.location.href);
        }
    }, [to]);

    // iOS-compatible redirect with fallback
    React.useEffect(() => {
        // Try multiple redirect methods for better iOS compatibility
        const redirect = () => {
            if (window.location.hostname.toLowerCase().includes('test') || window.location.hostname.toLowerCase().includes('staging')) {
                console.log('Attempting redirect to:', to);
            }
            
            try {
                // Method 1: window.location.assign (preferred)
                window.location.assign(to);
            } catch (error) {
                console.warn("window.location.assign failed, trying window.location.href:", error);
                try {
                    // Method 2: window.location.href (fallback)
                    window.location.href = to;
                } catch (error2) {
                    console.warn("window.location.href failed, trying window.open:", error2);
                    try {
                        // Method 3: window.open (last resort)
                        window.open(to, '_self');
                    } catch (error3) {
                        console.error("All redirect methods failed:", error3);
                    }
                }
            }
        };

        // Small delay to ensure DOM is ready, especially important for iOS
        const timeoutId = setTimeout(redirect, 100);
        
        return () => clearTimeout(timeoutId);
    }, [to]);

    return (
        <div
            className="d-flex flex-column justify-content-center text-center align-items-center"
            style={{ height: "80vh" }}
        >
            <h1>{t("RedirectScreen.header")}</h1>
            <p>{explanation || t("RedirectScreen.body")}</p>
            <Loader style={{ alignItems: "center" }} color="primary" />
            <p style={{ marginTop: "1rem" }}>
                {t("RedirectScreen.pressButtonIfFail")}
            </p>
            <Button color="primary" component={"a"} href={to}>
                {t("RedirectScreen.redirectButton")}
            </Button>
        </div>
    );
};

export default RedirectScreen;
